<script setup lang="ts">
import { BButton, BCard } from 'bootstrap-vue-next';
import { ref } from 'vue';

import AddPointsModal from '~/pages/user-page/AddPointsModal.vue';

const showModal = ref(false);
</script>

<template>
  <BCard
    title="Issue bonus points"
    class="h-100"
  >
    <p class="text-body-secondary">
      Award bonus points to one or more contributors.
    </p>
    <BButton
      variant="outline-primary"
      @click="showModal = true"
    >
      Issue bonus points
    </BButton>

    <AddPointsModal v-model="showModal" />
  </BCard>
</template>
